export default __webpack_public_path__ + "static/media/cases7.d4b81231.webp";